import { apiService } from 'services'

import { EventResponse, IEvent } from 'types'

const URL = '/babies'

const getEvents = async (babyId: number, isCompleted: boolean) =>
  apiService.get<EventResponse>(`${URL}/${babyId}/events?isCompleted=${isCompleted}`)

const getMoreEvents = async (babyId: number, minStartTime: string) =>
  apiService.get<EventResponse>(`${URL}/${babyId}/events`, {
    params: {
      minStartTime,
    },
  })

const createEvent = async (babyId: number, data: IEvent) =>
  apiService.post(`${URL}/${babyId}/events`, data)

const editEvent = async (babyId: number, eventId: string, data: IEvent) =>
  apiService.put(`${URL}/${babyId}/events/${eventId}`, data)

export const deleteEvent = async (babyId: number, eventId: string) =>
  apiService.delete(`${URL}/${babyId}/events/${eventId}`)

export const EventApi = { getEvents, createEvent, editEvent, getMoreEvents, deleteEvent }
